export default (theme) => ({
  forgotPassword: {
    marginTop: 40,
    fontSize: 18,
    textDecoration: 'none',
    transition: 'color .2s linear',
    color: theme.palette.secondary.main,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xl')]: {
      marginTop: 25,
      fontSize: 16,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 40,
      fontSize: 18,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      fontSize: 16,
    },
  },
});
